<template>
    <div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 p-3 border-right">
                <div class="form-group" v-for="taxInput in taxInputs.slice(0,2)" :key="taxInput.id">
                    <label class="form-label">{{taxInput.text}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fas fa-file-invoice-dollar"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="taxInput.text" v-model="receiptTax[taxInput.id]">
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 p-3">
                <div class="form-group" v-for="taxInput in taxInputs.slice(2,4)" :key="taxInput.id">
                    <label class="form-label">{{taxInput.text}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fas fa-file-invoice-dollar"></i>
                            </span>
                        </div>
                        <input type="text" class="form-control bg-transparent pl-3" :placeholder="taxInput.text" v-model="receiptTax[taxInput.id]">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import input from './../../../../assets/js/dashboard/input'
export default {
    name:'receiptTax',
    props:{
        taxation:{ type: Object }
    },
    data(){
        return{
            taxInputs: []
        }
    },
    computed:{
        receiptTax(){
            var ret = {};
            for (var t in this.taxation){
                for(var i = 0; i < this.taxInputs.length; i++){
                    if(t == this.taxInputs[i].id){
                        ret[this.taxInputs[i].id] = this.taxation[t];
                    }
                }
            } 
            return ret;
        }
    },
     watch:{
        "$i18n.locale"(val){
            this.setLabel()
        }
    },
    methods:{
        submitTax(){
            var data = {
                taxation: this.receiptTax
            };
            return data;
        },
        setLabel(){
            this.taxInputs = input.taxInputs
            for(var i = 0; i < this.taxInputs.length; i++){
                this.taxInputs[i].text = this.$i18n.messages[this.$i18n.locale].outlet_setting.info.tax[this.taxInputs[i].id]
            }
        }
    },
    mounted(){
        let $vm = this
        $vm.setLabel()
    },
}
</script>